import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { CityGroupsManager } from "@/components/admin/CityGroupsManager";

const CityGroups = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="City Groups"
        description="Configure city groups and locations"
      />
      
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">City Groups</h1>
          <p className="text-muted-foreground">
            Manage city groupings for regional pages
          </p>
        </div>

        <CityGroupsManager />
      </div>
    </>
  );
};

export default CityGroups;
